import React from "react";
import { ToastContainer } from "react-toastify";

/** Single app-wide toast host — top-right, Credora-styled via credoraToast.js */
const CredoraToastContainer = () => (
  <ToastContainer
    position="top-right"
    autoClose={4000}
    newestOnTop
    closeOnClick
    pauseOnFocusLoss
    draggable
    pauseOnHover
    limit={4}
    className="credora-toast-container"
    toastClassName="credora-toast-host"
    bodyClassName="credora-toast-body"
    progressClassName="credora-toast-progress"
  />
);

export default CredoraToastContainer;
